import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '@/views/login'
import layout from '@/layout'
Vue.use(VueRouter)

// 路由配置
const routes = [
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/',
    name: 'layout',
    component: layout,
    children: [
      // 系统主页
      // {
      //   path: '/index/index/login',
      //   name: 'home',
      //   component: () => import('@/views/index')
      // },
      {
        path: '/index/index/info',
        component: () => import('@/views/personalInfo')
      },
      // 系统管理
      {
        path: 'system/platform/account',
        component: () => import('@/views/system/admin')
      },
      {
        path: 'system/version',
        component: () => import('@/views/system/version')
      },
      {
        path: 'system/platform/role',
        component: () => import('@/views/system/role')
      },
      {
        path: 'system/platform/node',
        component: () => import('@/views/system/menu')
      },
      {
        path: 'business/user/user',
        component: () => import('@/views/list/user')
      },
      {
        path: 'business/user/blacklist',
        component: () => import('@/views/list/blacklist')
      },
      {
        path: 'manage/order/apply',
        component: () => import('@/views/order/finance')
      },
      {
        path: 'management/bcplatform',
        component: () => import('@/views/bcplatform')
      },
      {
        path: 'agent/agent',
        component: () => import('@/views/agent/agent')
      },
      {
        path: 'businessman/system/merchant',
        component: () => import('@/views/merchant/addressbook')
      },
      {
        path: 'businessman/system/whitelist',
        component: () => import('@/views/whitelist/index')
      },
      {
        path: 'businessman/loginip/index',
        component: () => import('@/views/whitelist/merchantLogin/index')
      },
      {
        path: 'system/platform/whitelist',
        component: () => import('@/views/adminip/index')
      },

      {
        path: 'cardpool/manage',
        component: () => import('@/views/cardManage')
      },
      {
        path: 'statistical/management/carddailyIncome',
        component: () => import('@/views/statmanagement/carddailyIncome')
      },
      {
        path: 'statistical/management/reconciliation',
        component: () => import('@/views/statmanagement/reconciliation')
      },
      {
        path: 'statistical/management/platformProfit',
        component: () => import('@/views/statmanagement/platformProfit')
      },
      {
        path: 'statistical/management/platformHistoryList',
        component: () => import('@/views/statmanagement/platformHistoryList')
      },
      {
        path: 'order/management/quick',
        component: () => import('@/views/orderManagement/quickOrder')
      },
      {
        path: 'order/management/transfer',
        component: () => import('@/views/orderManagement/transferOrder')
      },
      {
        path: 'order/management/userTransfer',
        component: () => import('@/views/orderManagement/userTransfer')
      },
      {
        path: 'order/management/transferMerchant',
        component: () => import('@/views/orderManagement/merchantTransfer')
      },
      {
        path: 'order/management/sellOrder',
        component: () => import('@/views/orderManagement/sellOrder')
      },
      {
        path: 'order/management/newSellOrder',
        component: () => import('@/views/orderManagement/newSellOrder')
      },
      {
        path: 'order/management/buyOrder',
        component: () => import('@/views/orderManagement/buyOrder')
      },
      {
        path: 'order/management/freezeOrder',
        component: () => import('@/views/orderManagement/freezeOrder')
      },
      {
        path: 'trading/floor',
        component: () => import('@/views/tradingFloor')
      },
      {
        path: 'trading/floorV2',
        component: () => import('@/views/tradingFloorV2')
      },

      {
        path: 'trading/tradingThrid',
        component: () => import('@/views/tradingThrid')
      },

      {
        path: 'flow/management/user',
        component: () => import('@/views/flowManagement/userFlow')
      },
      {
        path: 'flow/management/admin',
        component: () => import('@/views/flowManagement/adminFlow')
      },
      {
        path: 'flow/management/merchant',
        component: () => import('@/views/flowManagement/merchantFlow')
      },
      {
        path: 'system/set',
        component: () => import('@/views/systemSet')
      },
      {
        path: 'statistics/statistics/index',
        component: () => import('@/views/statistics/index')
      },
      {
        path: 'statistics/statistics/drawOrder',
        component: () => import('@/views/statistics/drawOrder')
      },
      {
        path: 'statistics/statistics/rechargeOrder',
        component: () => import('@/views/statistics/rechargeOrder')
      },
      {
        path: 'statistics/statistics/security',
        component: () => import('@/views/statistics/security')
      },
      {
        path: 'statistics/statistics/trans',
        component: () => import('@/views/statistics/trans')
      },
      {
        path: 'statistics/statistics/transMerchant',
        component: () => import('@/views/statistics/transMerchant')
      },
      {
        path: 'statistics/statistics/rechargeWithdraw',
        component: () => import('@/views/statistics/rechargeWithdraw')
      },
      {
        path: 'statistics/sellOrderStatistics',
        component: () => import('@/views/statistics/sellOrderStatistics')
      },
      {
        path: 'statistics/buyOrderStatistics',
        component: () => import('@/views/statistics/buyOrderStatistics')
      },
      {
        path: 'statistics/thridOrderList',
        component: () => import('@/views/statistics/thridOrderList')
      },
      {
        path: 'order/trans/merchant/merTransMerchant',
        component: () => import('@/views/orderManagement/merTransMerchant')
      },
      {
        path: 'announcement/announcement',
        component: () => import('@/views/announcement')
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
